var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('div',{staticClass:"pt-6 pl-6"},[_c('h2',[_vm._v("Preferences")]),_c('div',{staticClass:"back-nav flex"},[_c('p',{on:{"click":_vm.redirect}},[_vm._v("Settings >>")]),_c('p',[_vm._v("Preferences")])])]),_c('div',{staticClass:"tab-cover"},[_c('Tabs')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }